import { HotelFilter, HotelQueryModel } from '@/__generated';
import Sidebar from '@/components/App/Sidebar/Sidebar';
import { apiSdk } from '@/httpClient';
import React from 'react';
import FilterBarLoading from './FilterBarLoading';
import { GetHotelAvailableParams, IHotelQuery } from '../type';
import Spin from '@/components/Spin';
import { HOTEL_CONFIG } from '@/config';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';

type Props = {
  setDisplayMap: (display: boolean) => void;
  sessionId: string | undefined | null;
  isLoading: boolean;
  onFilterChange: (params: Partial<GetHotelAvailableParams>, clearAllFilter?: boolean) => void;
  params: GetHotelAvailableParams | undefined;
  hotelQuery: IHotelQuery | null | undefined;
  displaySearchOnMobile: boolean;
  onCloseFilterOnMobile: () => void;
  onProviderChange: (isAllProvider: boolean) => void;
};

const getHotelFilterWithAllParams = (filterParams: Partial<GetHotelAvailableParams> | null | undefined, sessionId: string) => {
  return apiSdk.BookingService.getHotelFilters({ ...filterParams, sessionId: sessionId || '' } as any);
};
export default function FilterBarHotelSearch({
  setDisplayMap,
  sessionId,
  isLoading,
  onFilterChange,
  params,
  hotelQuery,
  displaySearchOnMobile,
  onCloseFilterOnMobile,
  onProviderChange,
}: Props) {
  const [hotelFilter, setHotelFilter] = React.useState<HotelFilter>();
  const [loading, setLoading] = React.useState<boolean>(true);
  React.useEffect(() => {
    if (sessionId && !isLoading) {
      getHotelFilterData(params);
    }
  }, [sessionId, params, isLoading]);

  const getHotelFilterData = async (filterParams: Partial<GetHotelAvailableParams> | null | undefined) => {
    setLoading(true);
    let dataFilter = await getHotelFilterWithAllParams(filterParams, sessionId || '');
    setLoading(false);
    setHotelFilter(dataFilter);
  };

  const _onFilterChange = (nextParams: Partial<GetHotelAvailableParams>, clearAllFilter?: boolean) => {
    onFilterChange(nextParams, clearAllFilter);
  };

  if (!hotelFilter || !sessionId) {
    return <FilterBarLoading />;
  }

  return (
    <div className="col-xl-3 sm:d-none md:d-none">
      <Spin loading={loading || isLoading}>
        {window.innerWidth > 1300 ? (
          <aside className="sidebar y-gap-40 xl:d-none">
            <div className="sidebar__item -no-border position-relative">
              <div
                className="flex-center"
                style={{
                  backgroundImage: `url(${HOTEL_CONFIG.mapSvgThumbnail})`,
                  height: '180px',
                  backgroundPosition: 'center',
                  backgroundSize: 'contain',
                  backgroundColor: '#f0f8ff',
                }}
              >
                <button
                  className="button py-15 px-24 -blue-1 bg-white text-dark-1 absolute"
                  onClick={() => {
                    setDisplayMap(true);
                  }}
                >
                  <i className="icon-destination text-22 mr-10" />
                  Show on map
                </button>
              </div>
            </div>
            {hotelFilter ? (
              <Sidebar
                onProviderChange={onProviderChange}
                sessionId={sessionId}
                params={params}
                hotelFilter={hotelFilter}
                onFilterChange={_onFilterChange}
                hotelQuery={hotelQuery}
              />
            ) : null}
          </aside>
        ) : null}

        {/* End sidebar for desktop */}
        {window.innerWidth < 1300 ? (
          <Modal fullscreen isOpen={displaySearchOnMobile}>
            <ModalHeader toggle={onCloseFilterOnMobile}>Filter Hotels</ModalHeader>
            <ModalBody>
              {hotelFilter ? (
                <aside className="sidebar y-gap-40">
                  <Sidebar
                    onProviderChange={onProviderChange}
                    sessionId={sessionId}
                    params={params}
                    hotelFilter={hotelFilter}
                    onFilterChange={_onFilterChange}
                    hotelQuery={hotelQuery}
                  />
                </aside>
              ) : null}
            </ModalBody>
          </Modal>
        ) : null}
      </Spin>
      {/* End mobile menu sidebar */}
    </div>
  );
}
